import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/pharmaceutical/data";
import { motion } from "framer-motion";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function DrugFormulation() {
  const products = [
    "Drug Formulation and Manufacturing Process Optimization Software",
    

  ];
  const data = {
    image: "/industries/pharmaceutical/Drug1.jpg",
    intro: `Welcome to the future of Pharmaceutical: with our Drug Formulation and Manufacturing Process Optimization Software. Explore a suite of tools designed to revolutionize drug formulation, enhance manufacturing processes, and elevate overall pharmaceutical productivity.`,
    keyFeatures: [
      {
        title: "Formulation design and simulation",
        content: "Utilize advanced tools for designing and simulating drug formulations for better outcomes.",
      },
      {
        title: "Process optimization",
        content: "Optimize manufacturing processes to enhance efficiency and product quality.",
      },
      {
        title: "Real-time monitoring and control",
        content: "Monitor and control manufacturing processes in real-time to ensure consistency and compliance.",
      },
      {
        title: "Data-driven decision support",
        content: "Make informed decisions using real-time data for better process management.",
      },
      {
        title: "Integration with manufacturing equipment",
        content: "Seamlessly integrate with various manufacturing equipment for comprehensive process control.",
      },
    ],
    howItWorks:
      "Discover how our software empowers pharmaceutical companies with real-time insights, allowing them to make data-driven decisions, optimize resource allocation, and maximize productivity through advanced formulation and process optimization techniques.",
    benefits: {
      title: "The advantages of implementing our Drug Formulation and Manufacturing Process Optimization Software are multifaceted",
      data: [
        "Improved drug formulation accuracy and consistency.",
        "Enhanced manufacturing efficiency and productivity.",
        "Reduced time-to-market for new drugs.",
        "Cost savings through optimized resource usage.",
        "Compliance with regulatory standards.",
      ],
    },
    industries:
      "Critical for pharmaceutical companies, research and development teams, and manufacturing enterprises looking to adopt advanced formulation and process optimization practices.",
    technology: `Learn how our software seamlessly integrates with various manufacturing equipment and data sources, creating a comprehensive drug formulation and process optimization ecosystem.`,
    support: `Access training resources and our support system for effective implementation and optimal use of Drug Formulation and Manufacturing Process Optimization Software.`,
    industry: `Understand how our software aligns with industry standards and regulatory requirements for drug formulation and manufacturing process optimization.`,
  };
  
    const content = "Embark on an oil and gas evolution with us! Whether you're exploring advancements in oil and gas technology, operational efficiency, sustainability practices, or any aspect of the industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our oil and gas solutions align seamlessly with your objectives, budget, and scope."
    return (
    <>
<Head>
    <title>Drug Formulation and Manufacturing Process Optimization Software | Enhance Processes | Techbrain Networks</title>
    <meta name="description" content="Optimize drug formulation and manufacturing processes with Techbrain Networks software, designed to enhance efficiency and ensure product quality." />
    <meta name="keywords" content="drug formulation, manufacturing optimization, pharmaceutical processes, Techbrain Networks" />
    <meta property="og:title" content="Drug Formulation and Manufacturing Process Optimization Software | Enhance Processes | Techbrain Networks" />
    <meta property="og:description" content="Enhance efficiency and ensure product quality in drug formulation and manufacturing with Techbrain Networks process optimization software." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/pharmaceutical/products/drug-formulation-and-manufacturing-process-optimization-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Drug Formulation and Manufacturing Process Optimization Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Drug Formulation and Manufacturing Process Optimization Software | Enhance Processes" />
    <meta name="twitter:description" content="Techbrain Networks software optimizes drug formulation and manufacturing processes to enhance efficiency and ensure high-quality products." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/pharmaceutical/products/drug-formulation-and-manufacturing-process-optimization-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Drug Formulation and Manufacturing Process Optimization Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Enhance efficiency and ensure product quality in drug formulation and manufacturing with Techbrain Networks process optimization software.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/pharmaceutical/products/drug-formulation-and-manufacturing-process-optimization-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
             <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#03AED2"} />

      <AppbarIndustry title={"Pharmaceutical"} homeLink={'/industries/pharmaceutical'} link={'/industries/pharmaceutical/products'} />
      <HeroSection img={"/industries/pharmaceutical/Drug-Formulation-and-Manufacturing-Process-Optimization-Software.avif"}>Drug Formulation and Manufacturing Process Optimization Software</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#000600",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#03AED2",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#03AED2"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
        {/* Industries */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

        {/* Energy Efficiency Strategies */}
        {/* <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Success Stories</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.stories}
          </Typography>
        </Box> */}

        {/* Contact Us */}
        {/* <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Contact Us</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.contactUs}
          </Typography>
        </Box> */}

        {/* Future Developments and Innovations*/}
 
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            Stay informed about upcoming features and innovations in tactical communication encryption technology.
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000600",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#03AED2"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

         
        <Box
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#03AED2",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
           <Box
            sx={{
              width: ["100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#03AED2"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#03AED2"} bg={"#000600"} />
    </>
  );
}

export default DrugFormulation;
